import { checkAndSendActivityReminders } from '../services/activityRemainders';
import { scheduleIstTask } from './cron.service';

export const initActivityRemainderCronJob = () => {
  // Runs every 5 minutes, based on IST time
  scheduleIstTask(
    '*/5 * * * *',
    checkAndSendActivityReminders,
    'Activity reminders checked and sent',
  );
};
